module.exports = __webpack_public_path__ + "static/media/hospital.b5f389e4.svg";